import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { Provider } from 'react-redux'
import store from './store/index'
import { VersionProvider } from './VersionControl/VersionContext';
import mixpanel from 'mixpanel-browser';

const Root = () => {

    mixpanel.init('571af03f9fd0e472414a208210d46092', {
      autocapture: false,
      record_sessions_percent: 100,
      api_host: 'https://api-eu.mixpanel.com',
    })

  return (
    <Provider store={store}>
      <VersionProvider>
        <MemoizedApp/>
      </VersionProvider>
    </Provider>
  );
}

const MemoizedApp = React.memo(App);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

